<span class="text-muted">
    <small>
      <span>
        {{revisionStatusName}}
      </span>
      {{changeDate | date:'d-MMM-yyyy h:mm a'}} by {{changedBy | username}}
    </small>
  </span>